export default "__VITE_ASSET__C_zN7eGi__"